export { DatePickerModule } from './components/datepicker.module';
export { DatePickerDirective } from './components/datepicker.directive';
export { DatePickerComponent } from './components/datepicker.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion-datepicker-3/index.js
// module id = 497
// module chunks = 216